import {BaseContainerModel} from '../base-container.model';
import {bl_applet_login_subject_link_RowClass, bl_applet_login_subject_link_ext_RowClass} from '../../dbschema';

export class UserAppletContainerModel extends BaseContainerModel {
  bl_applet_login_subject_link: bl_applet_login_subject_link_RowClass = new bl_applet_login_subject_link_RowClass();
  bl_applet_login_subject_link_ext: bl_applet_login_subject_link_ext_RowClass[] = [];
}
